import validateQuestionPoolSameScore from "pages/ManagementPage/utils/validateQuestionPoolSameScore/validateQuestionPoolSameScore";

export default validateQuestionPoolSameScore;
